import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartType, RadialChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { ChartService } from "../shared/chart.service";

@Component({
  selector: 'app-customerschart',
  templateUrl: './customerschart.component.html',
  styleUrls: ['./customerschart.component.css']
})
export class CustomerschartComponent implements OnInit {

  public radarChartOptions: RadialChartOptions;
  public radarChartLabels: Label[];
  public radarChartData: ChartDataSets[];
  public radarChartType: ChartType ;
  public radarChartColors: Color[];
  public radarChartReady:boolean = true;

  public BranchList: any[] = [];
  public CustomersCount: any[] = [];

  constructor(public chartService: ChartService) { }

  ngOnInit() {

    this.GetCustomerChart();
  }
  
  GetCustomerChart(){
    this.chartService.FetchCustomerChartsList().subscribe(data => {

    this.radarChartOptions = {
      responsive: true,
    };

    data.forEach(branchData => {
      this.BranchList.push(branchData.BranchName)
    });

    this.radarChartLabels = this.BranchList;

    data.forEach(branchData => {
      this.CustomersCount.push(branchData.CustomersCount)
    });

    this.radarChartData = [
      { data: this.CustomersCount, label: 'Customers Analysis' }
    ];

    this.radarChartColors = [
      {
        borderColor: 'pink',
        backgroundColor: 'rgba(170,51,106,0.28)',
      },
    ];

    this.radarChartType = 'radar';
    this.radarChartReady = true;
  })
  }

}
